import React from 'react';
import { useTranslation } from 'react-i18next';
import { ErrorCaption, FieldLabel, FormField, TextDataArea } from '../styled';

interface TextDataFieldProps {
  isLoading: boolean;
  value: string;
  touched?: boolean;
  error?: string;
  onChange: React.ChangeEventHandler<HTMLTextAreaElement>;
  onBlur: () => void;
}

const TextDataField = ({
  isLoading,
  value,
  touched,
  error,
  onChange,
  onBlur,
}: TextDataFieldProps) => {
  const { t } = useTranslation('common');

  return (
    <FormField>
      <FieldLabel>{t('assistant.ragStorageDialog.textData')}</FieldLabel>
      <TextDataArea
        component="textarea"
        id="rag-vector-data-select"
        name="textData"
        data-testid="context-dialog-text-input"
        rows={10}
        disabled={isLoading}
        hasError={touched && Boolean(error)}
        isLoading={isLoading}
        value={isLoading ? t('assistant.ragStorageDialog.loadingData') : value}
        onChange={(e) => onChange(e as React.ChangeEvent<HTMLTextAreaElement>)}
        onBlur={onBlur}
      />
      {touched && error && (
        <ErrorCaption variant="caption" color="error">
          {error}
        </ErrorCaption>
      )}
    </FormField>
  );
};

export default TextDataField;
